import PlayerUserLimitsActive from './PlayerUserLimitsActive.svelte';

import CumulativeLimit from './limits/cumulativeLimit.svelte';
import DepositLimit from './limits/depositLimit.svelte';
import ExclusionLimit from './limits/exclusion.svelte';
import LossLimit from './limits/lossLimit.svelte';
import MaxStake from './limits/maxStake.svelte';
import PaymentLimit from './limits/paymentLimit.svelte';
import SessionLimit from './limits/sessionLimit.svelte';
import SportsLimit from './limits/SportLimit.svelte';
import WageringLimit from './limits/wageringLimit.svelte';

!customElements.get('cumulative-limit-active') && customElements.define('cumulative-limit-active', CumulativeLimit);
!customElements.get('deposit-limit-active') && customElements.define('deposit-limit-active', DepositLimit);
!customElements.get('exclusion-limit-active') && customElements.define('exclusion-limit-active', ExclusionLimit);
!customElements.get('loss-limit-active') && customElements.define('loss-limit-active', LossLimit);
!customElements.get('maxstake-limit-active') && customElements.define('maxstake-limit-active', MaxStake);
!customElements.get('payment-limit-active') && customElements.define('payment-limit-active', PaymentLimit);
!customElements.get('session-limit-active') && customElements.define('session-limit-active', SessionLimit);
!customElements.get('sports-limits-active') && customElements.define('sports-limits-active', SportsLimit);
!customElements.get('wagering-limit-active') && customElements.define('wagering-limit-active', WageringLimit);


!customElements.get('player-user-limits-active') && customElements.define('player-user-limits-active', PlayerUserLimitsActive);
export default PlayerUserLimitsActive;
